import * as React from "react";
import { connect } from "react-redux";

import LoggedInContainer from "web_modules/shared/LoggedInContainer";
import { finishLoading as reduxFinishLoading } from "web_modules/underwriter_dashboard/actions";

const styles = require("./styles.module.scss");

class FourOhFour extends React.Component<any, any> {
  componentDidMount() {
    const { finishLoading } = this.props;
    finishLoading();
  }

  pusher: any;

  render() {
    return (
      <div className={styles.container}>
        <LoggedInContainer
          titleLink={{
            name: "",
            to: "/",
          }}
          headerLinks={[
            {
              name: "Capital Markets",
              to: "/capital-markets",
            },
            {
              name: "Loan Officer",
              to: "/loan-officer",
            },
            {
              name: "Reporting",
              to: "/reporting",
            },
            {
              name: "Settlement Agent",
              to: "/settlement-agent",
            },
            {
              name: "Underwriter",
              to: "/underwriter",
            },
            {
              name: "Tools",
              to: "/tools",
            },
          ]}
        >
          <div id="four-oh-four" className={styles.main}>
            <h2>Reasons you could have reached this page:</h2>
            <ul>
              <li>You tried to access a page that does not exist.</li>
              <li>You don&apos;t have the roles to access the page you are trying to access.</li>
            </ul>
            <br />
            <p>
              Please contact the support dev in{" "}
              <a
                href="https://homelight.slack.com/messages/CQHMPTY06"
                target="_blank"
                rel="noreferrer noopener"
              >
                #hlhl-engineering
              </a>{" "}
              if you think this is a problem.
            </p>
          </div>
        </LoggedInContainer>
      </div>
    );
  }
}

export default connect(null, { finishLoading: reduxFinishLoading })(FourOhFour);
